import { enumeratePlanningActionCandidates } from '../targeting/planning.js';
import { validate } from './validate.js';
/**
 * Public bot/UI seam. Candidate expansion stays observation-pure in targeting;
 * this boundary then delegates every complete action to the single
 * authoritative validator so callers never receive a known-illegal PlanCard.
 */
export function enumeratePlanningActions(state, registry, playerId, instanceId) {
    // This seam grows a committed plan for bots and scripted policies. Atomic
    // re-planning is an explicit correction flow: callers that need it first
    // enumerate against a projection with only the replaced entry removed, then
    // validate the resulting PlanCard against live state.
    if (state.players[playerId]?.staged.some((plan) => plan.instanceId === instanceId) === true)
        return [];
    return enumeratePlanningActionCandidates(state, registry, playerId, instanceId)
        .filter((action) => validate(state, action, playerId, registry).ok);
}
//# sourceMappingURL=enumeratePlanningActions.js.map